import { FIFA_ASSET_VERSION } from "@/constants/vars.constants";

export const tournaments = [
      {
    id: 1,
    title: "FIFA World Cup™",
    active: `/fifa/fifa-slide-1.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-1-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 2,
    title: "FIFA U-20 World Cup Chile 2025™",
    active: `/fifa/fifa-slide-2.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-2-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 3,
    title: "FIFA U-17 World Cup Qatar 2025™",
    active: `/fifa/fifa-slide-3.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-3-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 4,
    title: "FIFA Futsal Women's World Cup Philippines 2025™",
    active: `/fifa/fifa-slide-4.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-4-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },

  {
    id: 5,
    title: "FIFA Beach Soccer World Cup Seychelles 2025™",
    active: `/fifa/fifa-slide-5.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-5-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 6,
    title: "FIFA Women's World Cup Australia & New Zealand 2023™",
    active: `/fifa/fifa-slide-6.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-6-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 7,
    title: "FIFAe World Cup 2024™",
    active: `/fifa/fifa-slide-7.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-7-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 8,
    title: "FIFA U-17 Women's World Cup Morocco 2025™",
    active: `/fifa/fifa-slide-8.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-8-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
   {
    id: 9,
    title: "FIFA U-20 Women's World Cup Colombia 2024™",
    active: `/fifa/fifa-slide-9.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-9-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 10,
    title: "FIFA Intercontinental Cup 2024™",
    active: `/fifa/fifa-slide-10.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-10-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
  {
    id: 11,
    title: "FIFA Futsal World Cup Uzbekistan 2024™",
    active: `/fifa/fifa-slide-11.webp?v=${FIFA_ASSET_VERSION}`,
    inactive: `/fifa/fifa-slide-11-inactive.webp?v=${FIFA_ASSET_VERSION}`,
  },
];